import { date, mktime, strtotime } from '@Libs/panel/php-functions';

const Php = {date, mktime, strtotime};
const defaultConfig = {
    select: '#ddrc-select',
    dateFrom: '#ddrc-from',
    dateTo: '#ddrc-to'
};

function getRangeBySelectValue(value) {
    var dateFrom;
    var dateTo;
    var week;
                
    switch (value) {
        case 1: /* aktualny tydzień */
        case 2: /* poprzedni tydzień */
        case 3: /* dwa tygodnie temu */
        case 4: /* 3 tygodnie temu */
        case 5: /* 4 tygodnie temu */
            week = Php.date('W') - (value - 1);
            dateFrom = Php.strtotime(Php.date('Y') + '-W' + week + '-1');
            dateTo = dateFrom + (7 * 86400);

            break;
        case 6: /* aktualny miesiąc */
            dateFrom = Php.mktime(0, 0, 0, Php.date('n'), 1);
            dateTo = Php.mktime(0, 0, 0, parseInt(Php.date('n')) + 1, 1);

            break;
        case 7: /* poprzedni miesiąc */
            dateFrom = Php.mktime(0, 0, 0, parseInt(Php.date('n')) - 1, 1);
            dateTo = Php.mktime(0, 0, 0, Php.date('n'), 1);

            break;
        case 9: /* poprzedni rok */
            dateFrom = Php.mktime(0, 0, 0, 1, 1, parseInt(Php.date('Y')) - 1);
            dateTo = Php.mktime(0, 0, 0, 1, 1, Php.date('Y'));

            break;
        default: /* aktualny rok */
            dateFrom = Php.mktime(0, 0, 0, 1, 1, Php.date('Y'));
            dateTo = Php.mktime(0, 0, 0, 1, 1, parseInt(Php.date('Y')) + 1);
        
            break;
    }

    dateFrom = Php.date('d/m/Y', dateFrom);
    dateTo = Php.date('d/m/Y', dateTo);
    
    return {
        dateFrom: dateFrom,
        dateTo: dateTo
    }
}

function init(initialConfig) {
    const config = $.extend({}, defaultConfig, initialConfig);
    const $select = $(config.select);
    let $dateFrom;
    let $dateTo;

    if ($select.length) {
        $dateFrom = $(config.dateFrom);
        $dateTo = $(config.dateTo);
        
        $select.on('change', function() {
            const range = getRangeBySelectValue(parseInt($(this).val()));

            $dateFrom.data('daterangepicker').setStartDate(range.dateFrom);
            $dateTo.data('daterangepicker').setStartDate(range.dateTo);
        });
    }
}

export const DefinedDateRangeChooser = {
    init
}